export default {
      id: "action-icon-confirmed-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-confirmed",
      toString: function () {
        return this.url;
      }
    }